import React, { Component } from 'react';
import styled from 'styled-components';

import imageUpcomingProject from '../assets/images/upcomingProject.png';
import Button from './Button';
import media from '../styles/media';

class UpcomingProject extends Component {
  constructor(props) {
    super(props);
    this.label = 'View Website';
  }
  render() {
    return (
      <Root id="Projects">
        <ImageContainer>
          <UpcomingProjectImage />
        </ImageContainer>
        <TextContainer>
          <h4>Upcoming Project</h4>
          <h1>The Arbor</h1>
          <p>
            Set gracefully on the upper slopes of Kelowna’s Westbank is a world
            of contemporary amenities and an abundance of nature at every turn.
            A world that contains the essence of a naturally urban lifestyle.
          </p>
          {/* <a href="https://the-arbor-demo.netlify.com/" target="_blank">
            <Button label={this.label} />
          </a> */}
        </TextContainer>
      </Root>
    );
  }
}

export default UpcomingProject;

const Root = styled.div`
  position: relative;
  height: 950px;
  @media (min-width: ${media.md}) {
    height: 750px;
  }
`;

const ImageContainer = styled.div`
  text-align: right;
`;

const UpcomingProjectImage = styled.div`
  margin-top: 30px;
  width: 100%;
  height: 505px;
  background-image: url('/assets/images/upcomingProject.png');
  background-position: center;
  @media (min-width: ${media.md}) {
    background-size: cover;
    background-image: url('/assets/images/upcomingProject.png');
    width: 71%;
    height: 716px;
    position: absolute;
    right: 0px;
  }
`;

const TextContainer = styled.div`
  @media (min-width: ${media.md}) {
    width: 442px;
    height: 445px;
    top: 150px;
    left: 11%;
  }
  position: absolute;
  top: 450px;
  background: #eeeeee;
  box-shadow: 0 2px 22px 0 rgba(0, 0, 0, 0.19);
  width: 94%;
  padding-bottom: 55px;
  padding-left: 50px;
  padding-right: 50px;
  padding-top: 55px;
  h1 {
    color: #f57f29;
    margin-top: 12px;
    margin-bottom: 24px;
  }
  p {
    margin-bottom: 41px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/UpcomingProject.js